import { AutogenModelViewEdiOrder, AutogenRowViewEdiOrder } from "./autogen/AutogenModelViewEdiOrder";

export class ModelViewEdiOrder extends AutogenModelViewEdiOrder<RowViewEdiOrder> {
    constructor() {
        super(RowViewEdiOrder);
    }
}

export class RowViewEdiOrder extends AutogenRowViewEdiOrder {
}